import asyncThunk from '@/lib/asyncThunk'
import { Branding } from '@/out/branding'

type Request = Record<never, never>

export const retrieveBranding = asyncThunk<Request, Branding>({
  name: 'branding/retrieve',
  uri: '/branding',
})
